import React, { useEffect, useRef, useState } from 'react';
export const SLIDE_WIDTH = 1600;
export const SLIDE_HEIGHT = 900;
interface SlideStageProps {
  children: React.ReactNode;
}

/**
 * Renders deck slides on a fixed 16:9 canvas (1600×900) and scales that canvas
 * to fit the viewport, so every slide composition stays pixel-exact.
 */
export function SlideStage({
  children
}: SlideStageProps) {
  const containerRef = useRef<HTMLDivElement>(null);
  const [scale, setScale] = useState(0);
  useEffect(() => {
    const el = containerRef.current;
    if (!el) return;
    const update = () => {
      // Layout size (not the on-screen rect), so a rotated deck still scales
      // against its own landscape box.
      const width = el.offsetWidth;
      const height = el.offsetHeight;
      if (!width || !height) return;
      setScale(Math.min(width / SLIDE_WIDTH, height / SLIDE_HEIGHT));
    };
    update();
    // A slide can mount while its container is still settling (deck
    // transitions), so keep measuring rather than trusting the first frame.
    const raf = requestAnimationFrame(update);
    const observer = new ResizeObserver(update);
    observer.observe(el);
    window.addEventListener('resize', update);
    return () => {
      cancelAnimationFrame(raf);
      observer.disconnect();
      window.removeEventListener('resize', update);
    };
  }, []);
  return <div ref={containerRef} className="w-full h-full flex items-center justify-center bg-[#EEF2ED] overflow-hidden" data-id="element-285" data-mp="2177672642am0">
      <div style={{
      width: SLIDE_WIDTH,
      height: SLIDE_HEIGHT,
      transform: `scale(${scale || 1})`,
      transformOrigin: 'center center',
      visibility: scale ? 'visible' : 'hidden'
    }} className="relative flex-shrink-0" data-id="element-286" data-mp="18gym34s0lg4s">
        {children}
      </div>
    </div>;
}